import { TradingLoadingButton, TradingTextField } from '@trading-ui/core';
import TradingSelect from '@trading-ui/select';
import { useTranslation } from 'react-i18next';

import type { CreatePlantPayload, User } from '@/interfaces';

import { FormUtils } from '../../utils/form.utils';

import * as styles from './Form.css';

type Props = {
  form: CreatePlantPayload;
  isSubmitting: boolean;
  errors: Partial<Record<keyof CreatePlantPayload, string>>;
  updateField: (field: keyof CreatePlantPayload, value: string) => void;
  updateUsers: (users: { id: number; value: string; label: string }[]) => void;
  handleSubmit: () => void;
  companyUsers: User[];
  type: 'create' | 'update';
};

export default function CompanyCupsForm({
  form,
  isSubmitting,
  errors,
  companyUsers,
  updateField,
  updateUsers,
  handleSubmit,
  type,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.formContainer}>
      <TradingTextField
        label={t('settings.companyDetailsTab.companyCups.modal.identifierLabel')}
        value={form.identifier}
        onChange={(e) => updateField('identifier', e.target.value)}
        error={!!errors.identifier}
        helperText={errors.identifier}
        disabled={type === 'update'}
      />
      <TradingTextField
        label={t('settings.companyDetailsTab.companyCups.modal.aliasLabel')}
        value={form.alias}
        onChange={(e) => updateField('alias', e.target.value)}
        error={!!errors.alias}
        helperText={errors.alias}
      />
      <TradingSelect
        label={t('settings.companyDetailsTab.companyCups.modal.usersLabel')}
        options={FormUtils.getUsersOptions(companyUsers)}
        value={form.users}
        onChange={(value) => updateUsers(value)}
        multiple
        style={{ width: '400px' }}
      />
      <TradingLoadingButton
        label={
          type === 'create'
            ? t('settings.companyDetailsTab.companyCups.modal.createCupsButton')
            : t('settings.companyDetailsTab.companyCups.modal.updateCupsButton')
        }
        handleClick={handleSubmit}
        className={styles.button}
        loading={isSubmitting}
      />
    </div>
  );
}
